var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsIam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1306,
    height: 2500,
    viewBox: "0 0 256 490",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 165.75l-21 6.856 21.75 2.519-.75-9.375M19.955 206.806L128 213.714l108.045-6.908L128 185.75 19.955 206.806M234.5 175.125l21.5-2.519-21.5-5.731v8.25",
    fill: "#3C4929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.387 352.929l56.606 13.396-56.756 17.116.15-30.512",
    fill: "#B7CA9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 92.221V54.019L128 0l.482.405-.248 48.496-.234.102-.405 1.117-59.098 23.856-.542 84.037 31.452-5.29L128 147.002V490.03l-32.369-16.177v-45.771l-28.354-11.338V202.069l-47.322 4.737v-38.195L0 172.606v-72.408l19.955-7.977",
    fill: "#4B612C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.408 152.727l-32.131 6.424V73.28l32.131 10.018v69.429M183.925 27.959l52.106 26.06v38.202L256 100.198V172.6l-19.969-3.989v38.195l-25.441-2.538-21.881-2.199v42.939h47.336v39.284l-21.997 1.974v39.611l-53.692 10.672v45.77l53.57-15.899.122 40.38-53.692 21.282v45.771L128 490.03V147.002l28.572 5.71 30.583 4.038V73.966l-58.338-22.498-.817-2.465V0l55.925 27.959",
    fill: "#759C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.356 61.941L128 49.01 67.277 73.28l32.131 10.018 60.948-21.357",
    fill: "#3C4929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.277 73.28L128 49.01l12.775 5.104 19.581 7.827 28.353 11.353-1.515 1.541-28.876 8.991-1.74-.528L128 73.28 99.408 83.298 67.277 73.28",
    fill: "#3C4929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.578 83.298l32.131-10.004v85.864l-32.131-6.446V83.298",
    fill: "#4B612C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsIam);
export default __webpack_public_path__ + "static/media/aws-iam.caa8eb841dea3fe7477b0124848ea585.svg";
export { ForwardRef as ReactComponent };